import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_MY_PURCENT = "getMyPurcent"; 
export const GET_USER_CARD_LIST = "getUserCard";
export const SEND_CHECKOUT_REQUEST = "sendCheckoutRequest";
export const SEND_CHECKOUT_REQUEST_IR_WALLET = "sendCheckoutRequestIrWallet";
export const GET_CHECKOUTING = "getCheckouting";
export const GET_COUNT_MY_PURCENTS = "getCountMyPurcents";
//mutation types
export const SET_MY_PURCENT = "setMyPurcent";
export const SET_USER_CARD_LIST = "setUserCard";
export const SET_CHECKOUTING = "setCheckouting";
export const SET_COUNT_MY_PURCENTS = "setCountMyPurcents";

export default {
    state: {
        listPusrcent:[],
        listUserCard:[],
        amountCheckouting:0,
        countMyPurcents:0
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedMyPurcent(state) {
            return state.listPusrcent;
        },
        loadedUserCardList(state) {
            return state.listUserCard;
        },
        loadedCheckouting(state) {
            return state.amountCheckouting;
        },
        loadedCheckoutingIrWallet(state) {
            return state.amountCheckoutingIrWallet;
        },
        loadedCountMyPurcents(state) {
            return state.countMyPurcents;
        },
    },
    actions: {
        /**
         * Set the create countMyPurcents
         * @param state
         * @param payload
         */
         [GET_COUNT_MY_PURCENTS](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('my_purcents/identifiedCount',payload)
                .then((response) => {
                    context.commit(SET_COUNT_MY_PURCENTS,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listPusrcent
         * @param state
         * @param payload
         */
        [GET_MY_PURCENT](context,payload) {
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('my_purcents'+payload)
                .then((response) => {
                    context.commit(SET_MY_PURCENT,response)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [GET_USER_CARD_LIST](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('myusercards?is_business_partners=0',payload)
                .then((response) => {
                    // context.commit(SET_USER_CARD_LIST,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [SEND_CHECKOUT_REQUEST](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .postData('my_purcents/request',payload)
                .then((response) => {
                    context.commit(SET_USER_CARD_LIST,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [SEND_CHECKOUT_REQUEST_IR_WALLET](context,payload) {
            let id=payload.id;
            delete payload.id;
            return new Promise((resolve, reject) => {
            httpHelper
                .postData(`irwallets_request/${id}`,payload)
                .then((response) => {
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [GET_CHECKOUTING](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('my_purcents/amountRequested',payload)
                .then((response) => {
                    context.commit(SET_CHECKOUTING,response.result.amount)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
        [SET_MY_PURCENT](state, payload) {
            state.listPusrcent = [...payload];
        },
        [SET_CHECKOUTING](state, payload) {
            state.amountCheckouting = payload
        },
        [SET_COUNT_MY_PURCENTS](state, payload) {
            state.countMyPurcents = payload;
        },
       
    }
};